import i18next from "i18next";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import s from "./LangSwitch.module.scss";

const LangSwitch = () => {
  const [showLang, setShowLang] = useState(false);
  const { t } = useTranslation();

  const switchLang = (lang) => {
    if (lang === "en") {
      window.location.href = `${window.location.origin}/exhibition`;
    } else {
      window.location.href = `${window.location.origin}/exhibition?lang=it`;
    }
  };

  return (
    <div
      onMouseEnter={() => setShowLang(true)}
      onMouseLeave={() => setShowLang(false)}
      onPointerDown={() => setShowLang(!showLang)}
      className={s.switchLang}
    >
      {t("lang")}
      <span
        onClick={() => switchLang(i18next.language === "en" ? "it" : "en")}
        className={`${s.hiddenLang} ${showLang ? s.showLang : ""}`}
      >
        {i18next.language === "en" ? "it" : "en"}
      </span>
    </div>
  );
};

export default LangSwitch;
